const user = {
    state: {
        step: 0, // 0：填写就诊人信息，1：医生问诊，2：结束问诊（咨询结束），3：医生问诊（咨询结束）
        huafuUI: 0,
        hasMask: false,
        doctorInfo: {},
        urlParams: {},
        inquiryInfo: {},
        sourcePath: '',
        deviceType: '',
        endInquiry: {},
        timDuration: {
            videoStart: '',
            duration: 0
        },
        theme: '#E86922' // 睿择渠道主题色
    },
    mutations: {
        updateStep(state, step) {
            state.step = step
        },
        updateHuafuUI(state, data) {
            state.huafuUI = data
        },
        updateMask(state, has) {
            state.hasMask = has
        },
        updateDoctorInfo(state, doctorInfo) {
            state.doctorInfo = doctorInfo
        },
        updateUrlParams(state, urlParams) {
            state.urlParams = urlParams
        },
        updateInquiryInfo(state, data) {
            state.inquiryInfo = data
        },
        updateSourcePath(state, data) {
            state.sourcePath = data
        },
        updateDeviceType(state, deviceType) {
            if (deviceType) {
                state.deviceType = deviceType;
            }
        },
        updateEndInquiry(state, endInquiry) {
            state.endInquiry = endInquiry;
        },
        updateVideoStart(state) {
            state.timDuration.videoStart = new Date()
            state.timDuration.duration = 0
        },
        updateDuration(state) {
            state.timDuration.duration = new Date() - state.timDuration.videoStart
        }
    },
    actions: {},
    namespaced: true,
}

export default user
